// extracted by mini-css-extract-plugin
export default {"image":"sound_image__mk6do","image-area":"sound_image-area__wmO1W","inputs":"sound_inputs__nyKAx"};